var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSxWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6996 16.1155C15.4979 14.6817 12.3499 13.6282 10.8428 13.4657C9.33755 13.2996 6.6252 12.2264 9.06792 11.1229C11.3089 10.1105 13.4338 11.0551 14.2087 11.4943C14.2016 11.4872 14.1909 11.4818 14.1837 11.4783L11.1 6.61425L10.6768 6C10.6768 6 5.94488 6.14464 4.20748 9.65159C2.46472 13.1514 3.49145 15.2727 6.34665 16.7655C9.20363 18.2618 12.6838 18.1511 13.6891 19.2653C14.0462 19.6617 14.1069 20.0189 14.0337 20.3117L16.7336 16.1494C16.7121 16.1262 16.6979 16.1173 16.6979 16.1173L16.6996 16.1155Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3553 21.1635C8.75737 22.7241 6.72891 18.9761 6.72891 18.9761L2.95947 21.8777C5.70218 25.3775 9.65196 25.8935 9.65196 25.8935C9.88945 25.9364 10.1198 25.9685 10.3484 25.9989L13.6089 20.9724C13.4732 21.0974 13.3571 21.1635 13.3571 21.1635H13.3553Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2107 11.4943C14.2375 11.5085 14.266 11.5228 14.2928 11.5425C14.2696 11.5228 14.2393 11.5103 14.2107 11.4943Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7516 16.1478L14.0518 20.3101C13.9821 20.5975 13.7875 20.8279 13.6232 20.9707L10.3591 25.9972C12.309 26.083 13.8143 25.7401 14.9624 25.2241C17.2266 24.0795 18.2766 22.1635 18.2766 22.1635C19.1497 18.7976 17.0445 16.4549 16.7499 16.146L16.7516 16.1478Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5432 6.00179L14.393 11.689C14.393 11.689 14.3091 11.6336 14.1591 11.5426C14.5805 11.8068 15.0055 12.3496 15.0055 12.3496L17.7303 8.53201C15.9215 6.21249 10.545 6 10.545 6L10.5432 6.00179Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7549 9.73744L17.7282 8.53394L15.0051 12.3498L23.4618 25.2259H29.1311L18.7549 9.73744Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8373 6.75012L16.7358 16.1496C17.0305 16.4585 19.1357 18.8012 18.2625 22.1671L28.5048 6.75012H22.8373Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.7516 16.1478L14.0518 20.3101C13.9821 20.5975 13.7875 20.8279 13.6232 20.9707L10.3591 25.9972C12.309 26.083 13.8143 25.7401 14.9624 25.2241C17.2266 24.0795 18.2766 22.1635 18.2766 22.1635C19.1497 18.7976 17.0445 16.4549 16.7499 16.146L16.7516 16.1478Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSxWhite);
export default __webpack_public_path__ + "static/media/sx-white.51ddf3bfb76a610b59e29fc66128c000.svg";
export { ForwardRef as ReactComponent };